import { UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAILURE } from "../../actions";
const initialState = {
    uploading: false,
    success: false,
    error: null,
    data: null,
};
const fileUploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_FILE_REQUEST:
            return Object.assign(Object.assign({}, state), { uploading: true, success: false, error: null });
        case UPLOAD_FILE_SUCCESS:
            return Object.assign(Object.assign({}, state), { uploading: false, success: true, error: null, data: action.payload });
        case UPLOAD_FILE_FAILURE:
            return Object.assign(Object.assign({}, state), { uploading: false, success: false, error: action.payload });
        default:
            return state;
    }
};
export default fileUploadReducer;
